import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';
import * as targetApi from '../../lib/api/target';

// ==================== 액션 타입 ====================

// KPI 목록 조회
const [GET_KPI_LIST, GET_KPI_LIST_SUCCESS, GET_KPI_LIST_FAILURE] =
  createRequestActionTypes('target/GET_KPI_LIST');

// 목표 유형 설정
const SET_TARGET_TYPE = 'target/SET_TARGET_TYPE';

// KPI 목록 초기화
const RESET_KPI_LIST = 'target/RESET_KPI_LIST';

// ==================== 액션 생성자 ====================

export const getKpiList = createAction(GET_KPI_LIST, (searchData) => searchData);
export const setTargetType = createAction(SET_TARGET_TYPE, (targetTyp) => targetTyp);
export const resetKpiList = createAction(RESET_KPI_LIST);

// ==================== 사가 ====================

const getKpiListSaga = createRequestSaga(GET_KPI_LIST, targetApi.getKpiDefList);

export function* targetKpiSaga() {
  yield takeLatest(GET_KPI_LIST, getKpiListSaga);
}

// ==================== 초기 상태 ====================

const initialState = {
  targetTyp: 'SALES',  // 기본 목표 유형
  kpiList: [],
  error: null,
};

// ==================== 리듀서 ====================

const targetKpi = handleActions(
  {
    [GET_KPI_LIST_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      kpiList: data.list || [],
      error: null,
    }),
    [GET_KPI_LIST_FAILURE]: (state, { payload: error }) => ({
      ...state,
      kpiList: [],
      error,
    }),
    [SET_TARGET_TYPE]: (state, { payload: targetTyp }) => ({
      ...state,
      targetTyp,
    }),
    [RESET_KPI_LIST]: () => initialState,
  },
  initialState,
);

export default targetKpi;
